import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSign, faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { isBlank } from 'helpers/string_helpers';

const highlightsPerBlock = 6;
const highlightsToIgnore = ['Address', 'Property Name'];

export default class MapInfoBubbleContentV1 extends React.Component {
  static propTypes = {
    goToPropertyShow: PropTypes.func.isRequired,
    property: PropTypes.shape({
      id: PropTypes.number,
      address: PropTypes.string.isRequired,
      city: PropTypes.string,
      displayName: PropTypes.string.isRequired,
      propertyType: PropTypes.string.isRequired,
      state: PropTypes.string,
    }),
    selectedPropertyIds: PropTypes.array.isRequired,
    toggleSelectProperty: PropTypes.func.isRequired,
  };

  state = {
    showAllHighlights: false
  }

  cityState = () => {
    return [this.propertyOrEmpty().city, this.propertyOrEmpty().state].filter(v => !isBlank(v)).join(', ');
  }

  isSelected = propertyId => this.props.selectedPropertyIds.indexOf(propertyId) > -1;
  hasPropertyName = () => this.propertyOrEmpty().displayName !== this.propertyOrEmpty().address;
  propertyOrEmpty = () => this.props.property || {};

  highlights = () => {
    const property = this.propertyOrEmpty();
    const { highlights = [], propertyType } = property;
    if (propertyType) {
      return [['Property Type', propertyType]].concat(highlights);
    } else {
      return highlights;
    }
  }

  handleSelect = () => {
    const property = this.propertyOrEmpty();
    const { toggleSelectProperty } = this.props;

    if (property.id) {
      toggleSelectProperty(property);
    }
  }

  render() {
    const highlights = this.highlights();

    return <>
      {this.renderHeader()}
      {highlights.length > 0 ? this.renderHighlights() : this.renderEmptyState()}
    </>;
  }

  renderHeader() {
    const { goToPropertyShow } = this.props;

    const property = this.propertyOrEmpty();

    const activeListingsToolTip = (
      <Tooltip id="listings-tooltip" placement="top">
        <span>This property has active listings.</span>
      </Tooltip>
    );

    return (
      <div className="info-window-header">
        <div className="window-content">
          <div className="d-inline-flex">
            <input
              checked={this.isSelected(property.id)}
              className="checkbox--lg hidden-xs hidden-sm"
              type="checkbox"
              onChange={this.handleSelect}
            />
            <div className="property-header">
              <a className="property-title" onClick={e => goToPropertyShow(e, property)}>
                {property.displayName}
              </a>
              <div className="text-muted property-subtitle">{this.renderAddress()}</div>
            </div>
          </div>
          <div>
            {property.activeListings &&
            <OverlayTrigger overlay={activeListingsToolTip} placement="top">
              <FontAwesomeIcon className="listings-icon" icon={faSign} />
            </OverlayTrigger>
            }
            <a className="ml-4 mt-2 btn btn-xs btn-dark" onClick={e => goToPropertyShow(e, property)}>
              <span>View</span>
            </a>
          </div>
        </div>
      </div>
    );
  }

  renderEmptyState() {
    return (
      <div className="highlights hidden-xs hidden-sm text-center">
        <span className="text-muted">No property highlights</span>
      </div>
    );
  }

  visibleHighlights() {
    return this.highlights().filter(highlight => !highlightsToIgnore.includes(highlight[0]));
  }

  hasMoreHighlights() {
    return this.visibleHighlights().length > highlightsPerBlock;
  }

  toggleShowAllHighlights = (e) => {
    e.preventDefault();
    this.setState(({ showAllHighlights }) => ({ showAllHighlights: !showAllHighlights }));
  }

  renderToggleShowHighlights() {
    if (!this.hasMoreHighlights()) return;

    const [icon, label] = this.state.showAllHighlights ? [faChevronUp, 'See Less'] : [faChevronDown, 'See More'];

    return (
      <div className="text-center mt-3">
        <a className="clickable" name="highlights-show-link" onClick={this.toggleShowAllHighlights}>
          {label}
          <FontAwesomeIcon className="ml-2" icon={icon} size="1x" />
        </a>
      </div>
    );
  }

  renderHighlights() {
    const propertyHighlights = this.visibleHighlights().map(highlight => (
      <div className="highlight-content row" key={highlight[0]}>
        <span className="col-sm-6 pl-0"><strong>{highlight[0]}</strong></span>
        <span className="highlight-label col-sm-6">{highlight[1]}</span>
      </div>
    ));

    return (
      <div className="highlights hidden-xs hidden-sm">
        {this.state.showAllHighlights ? propertyHighlights : propertyHighlights.splice(0, highlightsPerBlock)}
        {this.renderToggleShowHighlights()}
      </div>
    );
  }

  renderAddress() {
    if (this.hasPropertyName()) {
      return (
        <React.Fragment>
          {this.propertyOrEmpty().address}
          <br />
          {this.cityState()}
        </React.Fragment>
      );
    } else {
      return this.cityState();
    }
  }
}
